import { X, Phone, Globe, MapPin } from "lucide-react";
import { ChatStore } from "@/stores/ChatStore";
import { Button } from "@/components/ui/button";

export function BrokerInfoOverlay() {
  const brokerInfo = ChatStore(state => state.brokerInfo);
  const setBrokerInfo = ChatStore(state => state.setBrokerInfo);

  if (!brokerInfo) {
    return null;
  }

  const handleClose = () => {
    setBrokerInfo(null);
  };

  return (
    <div className="overflow-hidden rounded-lg shadow-lg">
      <div className="bg-white opacity-95 p-4 max-w-sm">
        <div className="flex items-start justify-between mb-3">
          <h3 className="text-lg font-semibold text-gray-900">
            Ihr Vermittler
          </h3>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleClose}
            className="h-6 w-6 p-0"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>

        <div className="space-y-3">
          {/* Name */}
          <div>
            <p className="text-sm font-medium text-gray-700">Name</p>
            <p className="text-base text-gray-900">{brokerInfo.name}</p>
          </div>

          {/* Telefon */}
          {brokerInfo.telefon && (
            <div className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-gray-500" />
              <a
                href={`tel:${brokerInfo.telefon.replace(/\s/g, '')}`}
                className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
              >
                {brokerInfo.telefon}
              </a>
            </div>
          )}

          {/* Website */}
          {brokerInfo.website && (
            <div className="flex items-center gap-2">
              <Globe className="h-4 w-4 text-gray-500" />
              <a
                href={brokerInfo.website.startsWith('http') ? brokerInfo.website : `https://${brokerInfo.website}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
              >
                {brokerInfo.website.replace(/^https?:\/\//, '')}
              </a>
            </div>
          )}

          {/* Address with Google Maps Link */}
          {brokerInfo.address && (
            <div className="flex items-start gap-2">
              <MapPin className="h-4 w-4 text-gray-500 mt-0.5" />
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  `${brokerInfo.address.strasse || ''} ${brokerInfo.address.plz || ''} ${brokerInfo.address.ort || ''}`.trim()
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
              >
                <div>
                  {brokerInfo.address.strasse && <div>{brokerInfo.address.strasse}</div>}
                  {brokerInfo.address.plz && brokerInfo.address.ort && (
                    <div>{brokerInfo.address.plz} {brokerInfo.address.ort}</div>
                  )}
                </div>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
